import PublicHeader from "../../components/PublicHeader";
import PublicFooter from "../../components/PublicFooter";
import { Eyebrow, Fleuron } from "../../components/design";

export default function UeberUns() {
  return (
    <div className="paper-bg" style={{ minHeight: "100vh" }}>
      <PublicHeader />
      <main
        style={{
          maxWidth: 760,
          margin: "0 auto",
          padding: "12px 22px 30px",
          fontFamily: "var(--f-body)",
          color: "var(--ink)",
        }}
      >
        <section style={{ padding: "32px 0 24px" }}>
          <Eyebrow>Über Vitanara</Eyebrow>
          <h1
            style={{
              fontFamily: "var(--f-display)",
              fontWeight: 400,
              fontSize: 40,
              lineHeight: 1.02,
              letterSpacing: "-0.02em",
              margin: "0 0 18px",
              color: "var(--ink)",
            }}
          >
            Ein Brief von
            <br />
            den <em>Gründern</em>.
          </h1>

          <img
            src="/images/team.jpg"
            alt="Das Vitanara Team"
            className="photo-tone"
            style={{
              width: "100%",
              maxHeight: 200,
              objectFit: "cover",
              borderRadius: 6,
              border: "1px solid rgba(43,26,15,0.10)",
              display: "block",
              marginBottom: 24,
            }}
          />

          <p
            className="dropcap"
            style={{
              fontFamily: "var(--f-display)",
              fontSize: 17,
              lineHeight: 1.55,
              color: "var(--ink)",
              margin: "0 0 16px",
            }}
          >
            Meine Großmutter starb an einem Sonntag im Juni 2022. Auf dem
            Heimweg von der Beerdigung merkte ich, dass ich nicht mehr genau
            wusste, wie sie ihren ersten Mann kennengelernt hatte.{" "}
            <em>Im Zug, glaube ich</em>, sagte mein Vater.
          </p>
          <p
            style={{
              fontFamily: "var(--f-body)",
              fontSize: 16,
              lineHeight: 1.55,
              color: "var(--ink-soft)",
              margin: "0 0 14px",
            }}
          >
            Wir hatten unzählige Sonntagnachmittage gehabt, um zu fragen. Aber
            ich hatte nie gefragt.
          </p>
          <p
            style={{
              fontFamily: "var(--f-body)",
              fontSize: 16,
              lineHeight: 1.55,
              color: "var(--ink-soft)",
              margin: "0 0 14px",
            }}
          >
            Vitanara ist die Antwort auf diese Versäumnis. Wir haben Konrad
            und Ida gebaut, weil ein Anruf manchmal leichter ist als ein
            Besuch — und weil zwölf Wochen Zeit lassen, was eine Stunde nicht
            schafft.
          </p>

          <Fleuron style={{ margin: "20px 0 18px", color: "var(--ochre)" }} />

          <p
            style={{
              fontFamily: "var(--f-script)",
              fontSize: 28,
              color: "var(--oxblood)",
              margin: 0,
              transform: "rotate(-1deg)",
              display: "inline-block",
            }}
          >
            Kai &amp; Jan
          </p>
          <div
            style={{
              fontFamily: "var(--f-body)",
              fontStyle: "italic",
              fontSize: 13.5,
              color: "var(--ink-faint)",
              marginTop: 2,
            }}
          >
            Gründer · Schleswig-Holstein, Mai 2026
          </div>
        </section>

        <section style={{ padding: "12px 0 30px" }}>
          <Eyebrow>Das Team</Eyebrow>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
              gap: 12,
            }}
          >
            {[
              { n: "Kai", r: "Gründung & Produkt" },
              { n: "Jan", r: "Technik & Datenschutz" },
              { n: "Marie H.", r: "Stimme & Sprache" },
              { n: "Jonas R.", r: "Druck & Versand" },
            ].map((p) => (
              <div
                key={p.n}
                style={{
                  background: "var(--paper-50)",
                  border: "1px solid rgba(43,26,15,0.10)",
                  borderRadius: 12,
                  padding: "14px 12px 12px",
                  textAlign: "center",
                }}
              >
                <div
                  className="oval-frame"
                  aria-hidden
                  style={{
                    width: 56,
                    height: 56,
                    margin: "0 auto 8px",
                    background: "var(--paper-200)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontFamily: "var(--f-display)",
                    fontStyle: "italic",
                    fontSize: 22,
                    color: "var(--oxblood)",
                  }}
                >
                  {p.n[0]}
                </div>
                <div
                  style={{
                    fontFamily: "var(--f-display)",
                    fontWeight: 500,
                    fontSize: 14,
                    color: "var(--ink)",
                  }}
                >
                  {p.n}
                </div>
                <div
                  style={{
                    fontFamily: "var(--f-body)",
                    fontStyle: "italic",
                    fontSize: 12,
                    color: "var(--ink-faint)",
                    marginTop: 2,
                  }}
                >
                  {p.r}
                </div>
              </div>
            ))}
          </div>
        </section>

        <section style={{ padding: "0 0 12px" }}>
          <div
            style={{
              background: "var(--paper-200)",
              borderRadius: 14,
              padding: "20px 20px",
              border: "1px solid rgba(43,26,15,0.10)",
            }}
          >
            <Eyebrow>Stand heute</Eyebrow>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                gap: 14,
                textAlign: "center",
              }}
            >
              {[
                { n: "1.247", l: "Familien" },
                { n: "18.314", l: "Anrufe" },
                { n: "912", l: "gedruckte Bücher" },
              ].map((s) => (
                <div key={s.l}>
                  <div
                    style={{
                      fontFamily: "var(--f-display)",
                      fontStyle: "italic",
                      fontSize: 24,
                      color: "var(--oxblood)",
                      lineHeight: 1,
                    }}
                  >
                    {s.n}
                  </div>
                  <div
                    style={{
                      fontFamily: "var(--f-body)",
                      fontSize: 11.5,
                      fontStyle: "italic",
                      color: "var(--ink-faint)",
                      marginTop: 4,
                    }}
                  >
                    {s.l}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <PublicFooter />
    </div>
  );
}
